import { render, staticRenderFns } from "./HotPointModal.vue?vue&type=template&id=db221710&scoped=true&"
import script from "./HotPointModal.vue?vue&type=script&lang=js&"
export * from "./HotPointModal.vue?vue&type=script&lang=js&"
import style0 from "./HotPointModal.vue?vue&type=style&index=0&id=db221710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db221710",
  null
  
)

export default component.exports